
subscribe('cart-update', (eventData) => {
    if (eventData.source == 'cart-items') {
        eventCartChange(eventData)
    } else if (eventData.source == 'product-form') {
        eventFormAdd(eventData)
    }
});

function eventFormAdd(eventData) {
    const form = eventData.form;

    if (!form) return;

    const cartData = eventData.cartData;
    const cart = eventData.cart;
    const variantId = Number(eventData.productVariantId);

    const addonInputs = Array.from(form).flatMap(el =>
        Array.from(el.querySelectorAll('.custom-input-wrapper select option[data-variant]:checked'))
      );
    // ('.custom-input-wrapper select option[data-variant]:selected');
    let formData = {
        items: []
    };

    addonInputs.forEach(i => {
        formData.items.push({
            id: Number(i.dataset.variant),  // Assuming input value is the 'id'
            quantity: 1,
            properties: {
                '_parent_product': variantId
            }
        });
    });

    if (formData.items.length > 0) {

        formData.sections = cart.getSectionsToRender().map((section) => section.id);
        console.log('formData contains items:', formData);

        formData.sections_url = window.location.pathname;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((response) => {
            cart.renderContents(response);

    //   this.querySelector('.drawer__inner').classList.remove('is-empty');

        })
        .catch((error) => {
            console.error('Error:', error);
        });

    }
}

function eventCartChange(eventData) {
    const addonIds = [];
    const cartItems = eventData.cartData.items
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const cartRemoved = eventData.cartData.items_removed[0]

    if ( cartRemoved ) {
        cartItems.forEach(item => {
            const properties = item.properties;

            Object.keys(properties).forEach(key => {
                if (key.includes('_parent_product') && properties[key] == cartRemoved.variant_id ) {
                    const parentExists = cartItems.filter(e=> e.id == properties[key])

                    if (parentExists.length > 0) {
                        addonIds.push({ [item.variant_id]: parentExists[0].quantity });
                    } else {
                        addonIds.push({ [item.variant_id]: 0 });
                    }
                }
            });
        });
    } else {
        cartItems.forEach(item => {
            const properties = item.properties;
            Object.keys(properties).forEach(key => {
                if (key.includes('_Addon')) {
                    addonIds.push({ [properties[key]]: item.quantity });
                }
            });
        });
    }

    if (addonIds.length == 0) return;

    var formData = new FormData();
    
    addonIds.forEach(addon => {
        Object.entries(addon).forEach(([id, quantity]) => {
            console.log(`updates[${id}] ${quantity}`);
            formData.append(`updates[${id}]`, quantity);
        });
    });

    if (cart) {
        formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then((response) => {
        cart.renderContents(response);

        if (response.items.length == 0) {
            if (cart) cart.classList.add('is-empty');
        }
    }).finally(() => {

    });
}